import RichTextButtonGroup from '@/components/sections/builder/elements/body/rich-text/button-group';
import ElementContentTeks from '@/components/sections/builder/elements/body/rich-text/content';
import Heading from '@/components/sections/builder/elements/body/rich-text/heading';
import ElementSettingTeks from '@/components/sections/builder/elements/body/rich-text/setting';
import Subtitle from '@/components/sections/builder/elements/body/rich-text/subtitle';
import { RichTextElementDataType } from '@/components/sections/builder/elements/body/rich-text/types';
import { GalleryHorizontal } from 'lucide-react';

const defaultData: RichTextElementDataType = {
  name: 'Rich Text',
  contentAlign: 'center',
  contentAlignMobile: 'center',
  height: 'small',
  showContainerDesktop: true,
  contentPosition: 'middle-center',
  firstImage: 'https://placehold.co/300x200',
  backgroundAnimation: 'none',
  mobileMinWidth: 720,
};

export const ElementPreviewIcon = GalleryHorizontal;

const RichText = {
  type: 'rich_text',
  group: 'body',
  defaultData,
  Element: ElementContentTeks,
  Setting: ElementSettingTeks,
  PreviewIcon: ElementPreviewIcon,
  defaultChilds: [Heading, Subtitle, RichTextButtonGroup],
  childs: [Heading, Subtitle, RichTextButtonGroup],
};

export default RichText;
